<template>
  <div>
    <b-card
      class="mb-2 shadow bg-light"
    >
      <b-card-title title-tag="h6">Factures émises par le créancier</b-card-title>
      <b-button v-if="createInvoice && $store.getters.isAdmin" @click="ajouter" size="sm" class="mb-2" title="Nouvelle facture"
        ><b-icon-plus-circle-fill></b-icon-plus-circle-fill></b-button
      >
      <p v-else-if="$store.getters.isAdmin"><i>Vous ne pouvez pas modifier les factures car il y a un arrangement pour ce mandat</i></p>
      <b-table
        v-if="invoices.length > 0"
        small
        id="invoicesTable"
        responsive
        striped
        hover
        :fields="invoicesFields"
        :items="invoices"
      >
        <template v-slot:cell(type)="data">
          {{ data.item.type == "facture" ? "Facture" : "Note de crédit" }}
        </template>
        <template v-slot:cell(date)="data">{{
          toDate(data.item.date)
        }}</template>
        <template v-slot:cell(echeance)="data">{{
          toDate(data.item.echeance)
        }}</template>
        <template v-slot:cell(montant)="data"
          >{{ twoDigits(data.item.montant) }} €</template
        >
        <template v-slot:cell(solde)="data"
          >{{ twoDigits(data.item.solde) }} €</template
        >
        <template v-slot:cell(actions)="data">
          <template v-for="(entry, i) in actions">
             <b-button
              v-if="
                  entry.condition == undefined || entry.condition(data.item)
                "
              :title="entry.label"
              size="sm"
              :icon="entry.icon ? true : false"
              :class="entry.icon ? 'btn-xs mr-2' : 'mr-2'"
              :key="i"
              :variant="entry.variant ? entry.variant : ''"
              @click="entry.event(data.item)"
            >
              <b-icon v-if="entry.icon" :icon="entry.icon"></b-icon>
              <span v-else>{{ entry.label }}</span>
            </b-button>
          </template>
          
        </template>
        <template v-slot:bottom-row>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>
            <strong>Total</strong>
          </td>
          <td>
            <strong>
              <span class="float-right"
                >{{
                  invoices
                    .reduce((a, b) => a + parseFloat(b.montant), 0)
                    .toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                }}
                €</span
              >
            </strong>
          </td>
          <td>
            <strong>
              <span class="float-right"
                >{{
                  invoices
                    .reduce((a, b) => a + parseFloat(b.solde), 0)
                    .toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                }}
                €</span
              >
            </strong>
          </td>
          <td/>
        </template>
      </b-table>
      <b-card-body v-else>
        <b-alert show>Pas de factures</b-alert>
      </b-card-body>
    </b-card>
    <b-modal id="modal-modifier-facture" title="Modifier une facture créancier" hide-footer>
      <WarrantInvoice @change="load(true)" @close="$bvModal.hide('modal-modifier-facture')" :invoice_id="invoice_id" :warrant_id="warrant_id"></WarrantInvoice>
    </b-modal>
    <b-modal id="modal-ajouter-facture" title="Ajouter une nouvelle facture créancier" hide-footer>
      <WarrantInvoice @change="load(true)" @close="$bvModal.hide('modal-ajouter-facture')" invoice_id="new" :warrant_id="warrant_id"></WarrantInvoice>
    </b-modal>
  </div>
</template>

<script>
import DateTime from "@/services/DateTime.js";
import warrants from "@/services/warrants.js";
import WarrantInvoice from "@/components/WarrantInvoice.vue";
export default {
  name: "warrant-invoices",
  props: ["id", "createInvoice"],
  components: {
    WarrantInvoice
  },
  data() {
    return {
      loaded: false,
      invoices: [],
      invoice_id: null,
      warrant_id: null,
      actions: [
            {
              label: "supprimer",
              event: this.supprimer,
              icon: "x-circle-fill",
              variant:"danger",
              condition: () => this.$store.getters.isSuperAdmin
            },
            {
              label: "modifier",
              event: this.modifier,
              icon: "pencil-square",
              variant: "success"
            },
          ],
      invoicesFields: [
        {
          key: "type",
          label: "Type",
          sortable: true,
        },
        {
          key: "numero",
          label: "Numéro",
          sortable: true,
        },
        {
          key: "date",
          label: "Date",
          sortable: true,
        },
        {
          key: "echeance",
          label: "Échéance",
          sortable: true,
        },

        {
          key: "reference_client",
          label: "Ref. client",
          sortable: false,
        },
        {
          key: "note",
          label: "Note",
          sortable: false,
        },
        {
          key: "montant",
          label: "Montant",
          class: "text-right",
          sortable: true,
        },
        {
          key: "solde",
          label: "Solde",
          class: "text-right",
          sortable: true,
        },
        {
          key: "actions",
          label: "",
          class: "text-center"
        },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    load(emit = false) {
      warrants.invoices(this.$props.id).then((response) => {
        this.invoices = response.data;
        if(!this.$props.createInvoice) {
          this.invoicesFields.pop();
        }
        this.loaded = true;
        if(emit) {
          this.$emit('change');
        }
      });
    },
    supprimer(row) {
      warrants.delete_invoice({
        warrant_id: row.mandatID,
        invoice_id: row.ID
      }).then((response) => {
        if(response.data.success) {
          this.load();
        }
      });
    },
    modifier(row) {
      this.warrant_id = row.mandatID;
      this.invoice_id = row.ID;
      this.$bvModal.show('modal-modifier-facture')
    },
    ajouter() {
      this.warrant_id = this.id;
      this.$bvModal.show('modal-ajouter-facture')
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>